module.exports = __webpack_public_path__ + "media/no12.5383285d.mp3";